// extracted by mini-css-extract-plugin
export default {"root":"_3frzp","text-block":"P-u3z","textBlock":"P-u3z","prefix":"_1o9Hi"};